import type { SimulatorProfileDefinition, SimulatorProfileId } from "../contracts/appManifest.js";
import { clientCloudAdminProfile } from "./client-cloud-admin.profile.js";
import { server2025Profile } from "./server-2025.profile.js";
import { serverCoreProfile } from "./server-core.profile.js";
import { workstationProfile } from "./workstation.profile.js";

export const simulatorProfiles: Record<SimulatorProfileId, SimulatorProfileDefinition> = {
  "client-cloud-admin": clientCloudAdminProfile,
  "server-2025": server2025Profile,
  "server-core": serverCoreProfile,
  workstation: workstationProfile
};

export function getSimulatorProfile(profileId: SimulatorProfileId): SimulatorProfileDefinition {
  return simulatorProfiles[profileId] ?? workstationProfile;
}
